export default __webpack_public_path__ + "static/media/startJourneyIcon.fbb02d86.svg";